import { Component, OnInit, Input, SimpleChanges, OnChanges, Output, forwardRef, EventEmitter, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, AbstractControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Privilege } from '../models/UserRelationship';

@Component({
  selector: 'app-privilege-dropdown',
  templateUrl: './privilege-dropdown.component.html',
  styleUrls: ['./privilege-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PrivilegeDropdownComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PrivilegeDropdownComponent),
      multi: true
    }
  ],
  encapsulation: ViewEncapsulation.None
})

export class PrivilegeDropdownComponent implements OnInit, OnChanges, ControlValueAccessor {

  @Input() privilegeGroup: Privilege[] = [];
  @Input() preSelectedPrivilege;
  @Input() filterPlaceHolder: string;
  @Input() defaultLabel: string;
  @Input() maxSelectedLabels: number;
  @Input() group: boolean;
  @Output() onChange = new EventEmitter<any[]>();

  disabled: boolean;
  items: SelectItem[];
  privilegesSelected: Privilege[] = [];
  privilegeIDArray: number[] = [];
  privilegeArray: any[] = [];
  processing = false;

  public onModelChange: (newValue: any) => void = () => { };
  public onModelTouched: (flag: boolean) => void = () => { };

  writeValue(value: any): void {
    this.privilegeGroup = value ? value : this.privilegeGroup;
  }

  registerOnChange(fn: any): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.partnershipPrivilege();
    this.populatePrivileges();
  }

  partnershipPrivilege(): void {
    const privilegeCategory: any[] = [];
    let privilegeCategoryIndex = -1;
    if (this.privilegeGroup !== undefined && this.privilegeGroup.length) {
    this.privilegeGroup.map((privilege) => {
      privilegeCategoryIndex = -1;
      privilegeCategory.filter((category, index) => {
        if (category.PrivilegeCategoryId === privilege.PrivilegeCategory.PrivilegeCategoryId) {
          privilegeCategoryIndex = index;
        }
      });
      if (privilegeCategoryIndex === -1) {
        privilegeCategory.push(privilege.PrivilegeCategory);
        privilegeCategoryIndex = privilegeCategory.length - 1;
        privilegeCategory[privilegeCategoryIndex].Privilege = [];
      }
      privilegeCategory[privilegeCategoryIndex].Privilege.push({
        'PrivilegeId': privilege.PrivilegeId
        , 'PrivilegeKey': privilege.PrivilegeKey
        , 'PrivilegeName': privilege.PrivilegeName
        , 'AccessTypeId': privilege.AccessTypeId
        , 'IsRevokableByParent': privilege.IsRevokableByParent
        , 'PrivilegeType': privilege.PrivilegeType
        , 'Enabled' : true
      });
    });
  }
    this.privilegeArray = privilegeCategory;
  }

  populatePrivileges(): void {
    this.processing = true;
    this.privilegesSelected = [];
    this.items = this.generateDesiredArray();
    if (this.preSelectedPrivilege !== undefined && this.preSelectedPrivilege.length) {
      this.privilegeIDArray = this.getSelectedPrivilegeID();
      this.items.filter(item => (item.disabled === false && this.privilegeIDArray.indexOf(item.value.PrivilegeId) != -1))
        .map(record => {
          this.privilegesSelected.push(record.value);
        });
    }
    // set timeout() is in place cause of this error "Expression has changed after it was checked"
    setTimeout(() => {
      this.change(this.privilegesSelected);
      this.processing = false;
    });
  }

  getSelectedPrivilegeID(): number[] {
    const privilegeID: number[] = [];
    this.preSelectedPrivilege.map((group) => {
        privilegeID.push(group.PrivilegeId);
    });
    return privilegeID;
  }

  generateDesiredArray(): SelectItem[] {
    const selectItems: SelectItem[] = [];
    this.privilegeArray.map((privilegeGroupRecord) => {
      selectItems.push({ label: privilegeGroupRecord.Key, value: privilegeGroupRecord.Key, disabled: true });
      privilegeGroupRecord.Privilege.map(privilege => {
        privilege.categoryID = privilegeGroupRecord.PrivilegeCategoryId;
        selectItems.push({ label: privilege.PrivilegeName, value: privilege, disabled: false });
      });
    });
    return selectItems;
  }

  getSelectedItems(selectedItems): any[] {
    let uniquePrivilegeGroup = [];
    let grpId: number;
    this.privilegeArray.map((privilegeGroupRecord, oIndex) => {
      grpId = privilegeGroupRecord.PrivilegeCategoryId;
      selectedItems.filter(privilege => {
        if (privilege.categoryID === grpId) {
          uniquePrivilegeGroup.push(privilegeGroupRecord);
        }
      });
    });
    uniquePrivilegeGroup = uniquePrivilegeGroup.filter((PrivilegeCategoryId, index, self) => self.indexOf(PrivilegeCategoryId) === index);
    const returnSelectedItems: any[] = [];
    uniquePrivilegeGroup.map((group) => {
      const grpID = group.PrivilegeCategoryId;
      group.Privilege = [];
      selectedItems.map((item) => {
        if (item.categoryID === grpID) {
          group.Privilege.push({
            IsSelected: true,
            PrivilegeName: item.PrivilegeName,
            PrivilegeID: item.PrivilegeId
          });
        }
      });
      returnSelectedItems.push(group);
    });
    return returnSelectedItems;
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return c.value ? null : { invalidForm: { valid: false, message: 'Please select an option' } };
  }

  change(newValue: any) {
    const privilege: any = {};
    this.onModelChange(newValue);
    privilege.Privileges = newValue;
    privilege.PrivilegesToolTip = this.getSelectedItems(newValue);
    this.onChange.emit(privilege);
  }

  blur() {
    this.onModelTouched(true);
  }
}
